import React, { useState, useEffect, useContext } from "react";
import classes from "./AddUser.module.scss";
import { useForm, Controller } from "react-hook-form";
import Button from "../components/UI/Button";
import axios from "axios";
import UsersTable from "../components/addUserComponents/UsersTable";
import { Container, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { UserUIStateContext } from "../store/userUIStateContext";
import { OrgIdContext, ClientTypes, CustomerRelations } from "../store/orgId_context";
import { DDD } from "../lib/ddd/ddd";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const AddUser = () => {
  const [feedback, setFeedback] = useState(null);
  const [usersList, setUsersList] = useState(null);
  const {sessionInfo, isTrustee, isSuperUser, customerRelation, clientType, getRoles} = useContext(OrgIdContext);
  const [canAdd, setCanAdd] = useState();
  const [canAddTrustee, setCanAddTrustee] = useState();
  const [canAddUser, setCanAddUser] = useState();
  const [canAddAdmin, setCanAddAdmin] = useState();
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();
  const {t} = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm(/*{defaultValues : { Name : "delete-ales", Lastname : "me", Email : "ales@e-invoices.online", role : "user"}}*/);

  const {
    handleSubmit:handleSubmit2,
    control:control2,
    formState: { errors:errors2 },
  } = useForm(/*{defaultValues : { Name : "delete-ales", Lastname : "me", Email : "ales@e-invoices.online", role : "user"}}*/);

  //console.log(getRoles());
  const onGetUsers = () => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetContentData",
            args: {
              Type: "orgusers",
            },
          },
          id: 111,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res?.data?.result && res?.data?.result?.Status?.toLowerCase() === "ok") {
          setUsersList(res?.data?.result?.Result);
        }
      });
  };

  /*useEffect(() => {
    onGetUsers();
  }, []);*/

  const onSubmit = (data) => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.AddUserForTransformer",
            args: {
              Name: data.firstName,
              LastName: data.lastName,
              Email: data.email,
              Role: data.role,
            },
          },
          id: 85,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        // console.log(res);
        if (res.data.result.Status.toLowerCase() === "ok") {
          setFeedback("ok");
          onGetUsers();
        } else {
          setFeedback("error");
        }
        setTimeout(() => {
          setFeedback(null);
        }, 2000);
      });
  };

  useEffect(() => {
    loadNewUsers();
  }, []);

  const loadNewUsers = () => {
    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteExtension("EUeInvoices.DDDI_GetMyUsers").then(res => {
      setUsersList(res?.result?.Result);
      setIsLoading(false);;
    });
  }

  const removeUser = (id) => {
    if(!id) return;
    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteExtension("EUeInvoices.DDDI_RemoveMyUser", {Id : id}).then(res => {
      if(res?.result?.Status === "Error" || res?.result?.error?.message) return _setError(res?.result?.Reason || res?.result?.error?.message || t("An error occured while trying to remove a team member."));
      setIsLoading(true);
      setTimeout(() => {loadNewUsers()}, 2000);
    });
  }

  useEffect(() => {
    //setCanAdd(canAddTrusteeF() || canAddUserF() || canAddAdminF());
    setCanAdd(isSuperUser);
    setCanAddUser(canAddUserF());
    setCanAddTrustee(canAddTrusteeF());
    setCanAddAdmin(canAddAdminF());
  }, [isTrustee, customerRelation, clientType]);

  /*SessionInfo.Get<string>("Country.IsoCode")),
  Culture = Get<string>("Culture", SessionInfo.Get<string>("Culture")),*/
  const onSubmit2 = (data) => {
    if(data.role !== "trustee" && data.role !== "admin")
     delete data.role;

    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteExtension("EUeInvoices.DDDI_AddMyUser", data).then(res => {
      if(res?.result?.Status === "Error" || res?.result?.error?.message) return _setError(res?.result?.Reason || res?.result?.error?.message || t("An error occured while trying to add a new team member."));
      setIsLoading(true);
      setTimeout(() => {loadNewUsers()}, 2000);
    });
  }

  const onSubmit3 = (data) => {
    if(data.role !== "trustee" && data.role !== "admin")
     delete data.role;

    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteExtension("EUeInvoices.DDDI_AddExistingUser", data).then(res => {
      if(res?.result?.Status === "Error" || res?.result?.error?.message) return _setError(res?.result?.Reason || res?.result?.error?.message || t("An error occured while trying to add a new team member."));
      setIsLoading(true);
      setTimeout(() => {loadNewUsers()}, 2000);
    });
  }

  const _setError = (msg) => {
    setError(msg);
    setTimeout(() => {setError(null)}, 3000);
  }

  const getNewUser = () => {
    let user = {};
    user.Country = sessionInfo?.Country?.IsoCode||"Serbia";
    user.Culture = sessionInfo?.Culture||"sr-Latn-RS";
    user.AuthProvider = "Username";
  }
  //Can i add new user?
  const canAddUserF = () =>{
    switch(clientType){
      case ClientTypes.ISV:
        if(!isTrustee) return false;
        if(customerRelation === CustomerRelations.EIOL)
          return true;
        return false;
      case ClientTypes.Company:
      case ClientTypes.AccService:
      case ClientTypes.Enterprise:
        return true;
      default:
        if(isTrustee) return true;
        return false;
    }
  }
  //Can i add new trustee?
  const canAddTrusteeF = () =>{
    switch(clientType){
      case ClientTypes.ISV:
        if(!isTrustee) return false;
        return true;
      case ClientTypes.Company:
      case ClientTypes.AccService:
      case ClientTypes.Enterprise:
        return true;
      default:
        if(isTrustee) return true;
        return false;
    }
  }

  //Can i add new trustee?
  const canAddAdminF = () =>{
    switch(clientType){
      case ClientTypes.ISV:
        if(!isSuperUser) return false;
        return true;
      case ClientTypes.Company:
      case ClientTypes.AccService:
      case ClientTypes.Enterprise:
        if(!isSuperUser) return false;
        return true;
      default:
        if(isSuperUser) return true;
        return false;
    }
  }

  return (
    <Container className={`h-100 w-100 p-5 ${classes.container}`}>
      <Row>
        {canAdd && <>
        <Col xs={12} lg={4}>
          <h2 className={`pt-2 pb-2 ${classes.title}`}>
            {t("Invite a new team member")}
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("An invitation mail will be sent to the user")}</Tooltip>}>
                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
            </OverlayTrigger>
          </h2>
          <section>
            <div className={classes["form-container"]}>
              <form onSubmit={handleSubmit(onSubmit2)}>
              {/* <fieldset className={classes["form-element"]}>
                  <label>Username*</label>
                  <Controller
                    name="Username"
                    control={control}
                    rules={{ required: "Username is required" }}
                    render={({ field }) => (
                      <>
                        <input {...field} type="text"/>
                        {errors.Username && (
                          <span>{errors.Username.message}</span>
                        )}
                      </>
                    )}
                  />
                </fieldset> */}
                <fieldset className={classes["form-element"]}>
                  <label>{t("First Name")}*</label>
                  <Controller
                    name="Name"
                    control={control}
                    rules={{ required: "First Name is required" }}
                    render={({ field }) => (
                      <>
                        <input {...field} type="text"/>
                        {errors.Name && (
                          <span>{errors.Name.message}</span>
                        )}
                      </>
                    )}
                  />
                </fieldset>
                <fieldset className={classes["form-element"]}>
                  <label>{t("Last Name")}*</label>
                  <Controller
                    name="Lastname"
                    control={control}
                    rules={{ required: "Last Name is required" }}
                    render={({ field }) => (
                      <>
                        <input {...field} type="text" />
                        {errors.Lastname && (
                          <span>{errors.Lastname.message}</span>
                        )}
                      </>
                    )}
                  />
                </fieldset>
                <fieldset className={classes["form-element"]}>
                  <label>{t("Email Address")}*</label>
                  <Controller
                    name="Email"
                    control={control}
                    rules={{
                      required: t("Email Address is required"),
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: t("Invalid email address"),
                      },
                    }}
                    render={({ field }) => (
                      <>
                        <input {...field} type="email" />
                        {errors.Email && <span>{errors.Email.message}</span>}
                      </>
                    )}
                  />
                </fieldset>
                <fieldset className={classes["form-element"]}>
                  <label>
                    {t("Role")}*
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>
                          <div style={{ textAlign: "left" }}>
                            {canAddUser && <><strong>User</strong> – Only has basic access, permission to use the applications.<br /></>}
                            <strong>Trustee</strong> – All access. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>} {canAddUser ? <>Can remove Users but not create them.</> : <>No user management.</>}<br />
                            <strong>Admin</strong> – All access. Full user management control. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>}
                          </div>
                        </Tooltip>
                      }
                    >
                        <span style={{ marginLeft: 6, cursor: "pointer", display: "inline-flex" }}>
                        <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                        </span>
                    </OverlayTrigger>
                  </label>
                  <Controller
                    name="role"
                    control={control}
                    rules={{ required: "Role is required" }}
                    render={({ field }) => (
                      <>
                        <select {...field}>
                          <option value="">{t("Select role")}</option>
                          {canAddUser && 
                          <option value="user">User</option>
                          }
                          {canAddTrustee && 
                          <option value="trustee">Trustee</option>
                          }
                          {canAddAdmin &&
                          <option value="admin">Admin</option>
                          }
                        </select>
                        {errors.role && <span>{errors.role.message}</span>}
                      </>
                    )}
                  />
                </fieldset>
                <Button type="submit" className="px-3 py-1 mt-2">
                  {("Submit")}
                </Button>
              </form>
            </div>
            {feedback && feedback === "ok" && (
              <p className="mt-3" style={{ color: "#df511d" }}>
                {t("User added successfully")}!
              </p>
            )}
            {feedback && feedback === "error" && (
              <p className="mt-3" style={{ color: "#df511d" }}>
                {t("An error occured while trying to add a new team member.")}
              </p>
            )}
            <h2 className={`pt-2 pb-2 mt-2 ${classes.title}`}>
              {t("Add an existing team member")}
              <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Add an existing user account to this organization")}</Tooltip>}>
                  <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
              </OverlayTrigger>
            </h2>
            <div className={classes["form-container"]}>
              <form onSubmit={handleSubmit2(onSubmit3)}>
              <fieldset className={classes["form-element"]}>
                  <label>{t("Username or user email")}*</label>
                  <Controller
                    name="Name"
                    control={control2}
                    rules={{ required: "Name is required" }}
                    render={({ field }) => (
                      <>
                        <input {...field} type="text"/>
                        {errors2.Name && (
                          <span>{errors2.Name.message}</span>
                        )}
                      </>
                    )}
                  />
                </fieldset>
                <fieldset className={classes["form-element"]}>
                  <label>
                    {t("Role")}*
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="long-tooltip" style={{ maxWidth: "400px", whiteSpace: "normal" }}>
                          <div style={{ textAlign: "left" }}>
                            {canAddUser && <><strong>User</strong> – Only has basic access, permission to use the applications.<br /></>}
                            <strong>Trustee</strong> – All access. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>} {canAddUser ? <>Can remove Users but not create them.</> : <>No user management.</>}<br />
                            <strong>Admin</strong> – All access. Full user management control. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>}
                          </div>
                        </Tooltip>
                      }
                    >
                        <span style={{ marginLeft: 6, cursor: "pointer", display: "inline-flex" }}>
                        <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                        </span>
                    </OverlayTrigger>
                  </label>
                  <Controller
                    name="role"
                    control={control2}
                    rules={{ required: "Role is required" }}
                    render={({ field }) => (
                      <>
                        <select {...field}>
                          <option value="">{t("Select role")}</option>
                          {canAddUser && 
                          <option value="user">User</option>
                          }
                          {canAddTrustee && 
                          <option value="trustee">Trustee</option>
                          }
                          {canAddAdmin &&
                          <option value="admin">Admin</option>
                          }
                        </select>
                        {errors2.role && <span>{errors2.role.message}</span>}
                      </>
                    )}
                  />
                </fieldset>
                <Button type="submit" className="px-3 py-1 mt-2">
                  {t("Submit")}
                </Button>
                {error && <div className="alert alert-danger mt-2" role="alert">
                    {error}
                </div>}
              </form>
            </div>
          </section>{" "}
        </Col>
        </> }
        <Col xs={12} lg={canAdd ? 8 : 12}>
          {!canAdd && <h2 className={`pt-2 pb-2 ${classes.title}`}>
            {t("Team members")}
            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("You do not have permission to add new team members. Please contact your organization administrator.")}</Tooltip>}>
                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
            </OverlayTrigger>
          </h2>}
          {usersList && <UsersTable usersData={usersList} refreshUsers ={loadNewUsers} loading={isLoading} removeUser={removeUser} canAddUser={canAddUser}/>}
        </Col>
      </Row>
    </Container>
  );
};

export default AddUser;
